import * as React from "react";
import useIsomorphicLayoutEffect from "use-isomorphic-layout-effect";
const breakPointOrder = ["xs", "sm", "md", "lg", "xl", "xxl"];
const defaultContext = {
  getIconPath: (name) => name,
  media: {
    width: {
      xs: {
        min: "20rem",
        max: "37.499rem"
      },
      sm: {
        min: "37.5rem",
        max: "49.999rem"
      },
      md: {
        min: "50rem",
        max: "62.499rem"
      },
      lg: {
        min: "62.5rem",
        max: "80.499rem"
      },
      xl: {
        min: "80.5rem",
        max: "90.624rem"
      },
      xxl: {
        min: "90.625rem"
      }
    }
  },
  locale: void 0,
  portalRoot: void 0,
  brand: "telia",
  theme: "light"
};
const ThemeContext = React.createContext(defaultContext);
const media = {
  width: {
    xs: {
      min: "20rem",
      max: "37.499rem"
    },
    sm: {
      min: "37.5rem",
      max: "49.999rem"
    },
    md: {
      min: "50rem",
      max: "62.499rem"
    },
    lg: {
      min: "62.5rem",
      max: "80.499rem"
    },
    xl: {
      min: "80.5rem",
      max: "90.624rem"
    },
    xxl: {
      min: "90.625rem"
    }
  }
};
const ThemeProvider = (props) => {
  const { brand = "telia", theme = "light", root, getIconPath, portalRoot: portalRootProp, locale, children } = props;
  useGlobalThemeAttributes({ brand, theme, root, portalRoot: portalRootProp });
  const defaultPortalRoot = typeof window !== "undefined" ? document.body : null;
  const portalRoot = portalRootProp != null ? portalRootProp : defaultPortalRoot;
  const contextValue = React.useMemo(
    () => ({
      getIconPath,
      media,
      locale,
      portalRoot,
      brand,
      theme
    }),
    [getIconPath, locale, portalRoot, brand, theme]
  );
  return /* @__PURE__ */ React.createElement(ThemeContext.Provider, { value: contextValue }, children);
};
const useGlobalThemeAttributes = ({ brand, theme, root: rootProp, portalRoot }) => {
  useIsomorphicLayoutEffect(() => {
    let root = rootProp;
    if (root === void 0) {
      root = document.documentElement;
    }
    if (!root) {
      return;
    }
    const originalBrand = root.dataset.brand;
    const originalTheme = root.dataset.theme;
    root.dataset.brand = brand;
    root.dataset.theme = theme;
    return () => {
      if (!root) {
        return;
      }
      root.dataset.brand = originalBrand;
      root.dataset.theme = originalTheme;
    };
  }, [brand, theme, rootProp]);
  useIsomorphicLayoutEffect(() => {
    const root = portalRoot;
    if (!root || root === rootProp) {
      return;
    }
    const originalBrand = root.dataset.brand;
    const originalTheme = root.dataset.theme;
    root.dataset.brand = brand;
    root.dataset.theme = theme;
    return () => {
      if (!root) {
        return;
      }
      root.dataset.brand = originalBrand;
      root.dataset.theme = originalTheme;
    };
  }, [brand, theme, portalRoot, rootProp]);
};
export {
  ThemeContext,
  ThemeProvider,
  breakPointOrder,
  defaultContext,
  media
};
